import React, { useState, useEffect, useCallback } from "react";
import "./login.css";
import Footer from "../../components/footer/Footer";
import { useSelector, useDispatch } from "react-redux";
import { Button, Grid } from '@material-ui/core';
import { useNavigate } from "react-router-dom";
import './intro.css';
import logo from "../../assets/images/CareConnectLogo_3.png";
import introBg from "../../assets/images/home_care_intro_1.png";






const Intro = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { auth } = useSelector((state) => state.auth);


  

  useEffect(() => {
    //alert(JSON.stringify(auth));
    if (auth?.data) {
      localStorage.setItem('userData', JSON.stringify(auth?.data))
    }
  }, [auth]);


  const toLogin = () => {
    navigate("/login");
  }

  const toRegister = () => {
    navigate("/register");
  }

  const toPolicy = () => {
    navigate("/policy");
  }

  const toPricing = () => {
    navigate("/pricing");
  }

  const toHome = () => {
    navigate("/intro");
  }

  return (
    <div
    style={{
      minHeight: "100vh",
      backgroundImage: `url(${introBg})`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundAttachment: "fixed" // optional nice effect
    }}
  >
    <Grid className="intro" container spacing={1} style={{
      minHeight: "90vh"
    }}>
      <Grid item xs={12} md={6} style={{color:'#367588', padding:'3rem'}}>
        {/* <img src={logo} alt="logo" width="80vh" /> */}
        {/* <h2>CareConnect</h2> */}
        <img onClick={(e) => {
                e.preventDefault();
                toHome()
              }} src={logo} alt="logo" height="120vh" />
      </Grid>
      <Grid item xs={12} md={6} style={{display:'flex', flexDirection:'row', padding:'3rem'}}>
        <Grid item xs={2} md={2}>
          
        </Grid>
        <Grid item xs={2} md={2}>
        <p className="top-menu" onClick={(e) => {
            e.preventDefault();
            toHome()
          }}>
            Home
          </p>
        </Grid>
        <Grid item xs={2} md={2}>
        <p className="top-menu" onClick={(e) => {
                e.preventDefault();
                toPricing()
              }}>
          Pricing
          </p>
        </Grid>
        <Grid item xs={2} md={2}>
          <p className="top-menu" onClick={(e) => {
                e.preventDefault();
                toPolicy()
              }}>
                Terms
          </p>
          
        </Grid>
        <Grid item xs={2} md={2}>
          
          <Button
              id="btn-nav-resend"
              size="small"
              variant="contained"
              color="primary"
              style={{backgroundColor:'#367588'}}
              onClick={(e) => {
                e.preventDefault();
                toLogin()
              }}
            >
             Login
            </Button>
        </Grid>
      </Grid>
      <Grid  item xs={12} md={12} style={{textAlign:'center', color:'#fff', alignItems:'center' }}>
        <div className="grid-intro">
          <h1 className="text-bordered" style={{textDecoration: 'none'}}>For home health services</h1>
          {/* <h1 className="text-bordered" style={{textDecoration: 'none'}}>Care that comes home</h1> */}
          </div>
      </Grid>
      
    </Grid>
    <Grid className="intro-why" container spacing={1} style={{}}>    
      <Grid item xs={12} md={12} style={{textAlign:'center', color:'#367588'}}>
       <Footer/>
    </Grid>
      </Grid>
    </div>
  );
};

export default Intro;
